module.exports = __webpack_public_path__ + "img/logo.92ef6f69.svg";